import { Box, Divider, Grid, Typography, useTheme } from "@mui/material";
import AddressIcon from "src/assets/icon/address";
import BoxIcon from "src/assets/icon/box";

// show supplier name, email, address, companyid
export const CustomSupplierListItem = ({
  option,
  index,
  getOptionProps,
  onChange,
  handleCloseMenu,
  icon,
}: any) => {
  const theme = useTheme();
  return (
    <Grid
      container
      component="li"
      {...getOptionProps({ option, index })}
      key={"option_" + option?.id + "_" + index}
      sx={{
        alignItems: "flex-start",
        padding: "8px 8px",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: theme.palette.action.hover,
        },
      }}
      onClick={() => {
        onChange(null, option);
        handleCloseMenu();
      }}
    >
      <Grid item xs={12}>
        <Box sx={{ display: "flex", alignItems: "top", gap: 1 }}>
          {option.logoURL ? (
            <img src={option.logoURL} height={20} width={20} />
          ) : icon ? (
            icon
          ) : (
            <BoxIcon height={20} width={20} />
          )}
          <Box>
            <Typography
              sx={{
                fontSize: "12px",
                color: "text.primary",
              }}
            >
              {option.name}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              {option.email && (
                <>
                  <Typography sx={{ fontSize: "11px", color: "#657482" }}>
                    {option.email}
                  </Typography>
                  <Divider
                    style={{
                      width: "1px",
                      height: "12px",
                    }}
                    light
                    orientation="vertical"
                  />
                </>
              )}
              <Typography
                sx={{
                  fontSize: "11px",
                  color: "text.secondary", //"#657482"]
                }}
              >
                {option.registrationNumber}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.25 }}>
              {option.address && (
                <>
                  <AddressIcon height={12} width={12} customColor="#657482" />
                  <Typography sx={{ fontSize: "11px", color: "#657482" }}>
                    {option.address}
                  </Typography>
                </>
              )}
            </Box>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};
